import { createSlice } from "@reduxjs/toolkit"

const serviceSlice = createSlice({
   name: "requests",
   initialState: {
      requests: [],
      isFetching: false,
      error: null,
   },
   reducers: {
      serviceStart: (state) => {
         state.isFetching = true
      },
      serviceFailure: (state, action) => {
         state.requests = []
         state.isFetching = false
         state.error = action.payload
      },
      getServiceSuccess: (state, action) => {
         state.requests = action.payload
         state.isFetching = false
         state.error = null
      },
      createServiceSuccess: (state, action) => {
         state.isFetching = false
         state.error = null
         state.requests.push(action.payload)
      },
   },
})

export const {
   serviceStart,
   serviceFailure,
   getServiceSuccess,
   createServiceSuccess,
} = serviceSlice.actions

export default serviceSlice.reducer
